import { NumberInput } from '../baseInputs'

type Props = {
  helper?: string
}

const Mileage = ({ helper, ...rest }: Props) => {
  const name = 'mileage'
  const label = 'Mileage'

  return <NumberInput name={name} label={label} helper={helper} {...rest} />
}

export default Mileage
